/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': 'Tài khoản này chưa đăng ký, vui lòng đăng nhập trước khi đăng ký.	',
    'no_zone_code': '(không yêu cầu số quốc gia)',
    '授权校验失败，请刷新页面并重试。': 'Authorization verification failed. Please refresh the page and try again.',
    'onlineService': 'Online service',
    'standardExpress': 'Chuyển phát chuẩn',
    'economyExpress': 'Chuyển phát tiết kiệm',
    'eParcel': 'Bưu gửi điện tử/ bưu gửi điện tử +',
    'overseasFulfilment': 'Chuyển phát nhanh thương mại điện tử quốc tế',
    'warehouse': 'Kho',
    'pleaseAgreePolicy': 'Please read and agree to the Privacy Policy',
    'pleaseAgreeToScan': 'Vui lòng đọc và đồng ý với điều khoản bên phải',
    'heavyFreight': 'Vận chuyển hàng hóa nặng',
    '验证码接收方式': 'Phương thức nhận mã xác minh',
    'cancelTips': 'Vui lòng đọc và đồng ý về thông báo hủy tài khoản',
    'confirmCancel': 'Xác nhận đăng xuất',
    'verificationCodeError': 'Lỗi CAPTCHA, vui lòng lấy lại CAPTCHA!',
    'clickGoDirectly': '(Click trực tiếp)',
    'repeatTips': 'Tài khoản của bạn có vấn đề trùng lặp, vui lòng truy cập<span class="mode">Chọn phương thức đăng nhập</span>sau đó đăng nhập, {count} sau vài giây',
    'repeatTips1': 'Bạn gặp sự cố trùng lặp với số điện thoại của mình, vui lòng truy cập<span class="mode">Chọn mã vùng</span>để đăng nhập, {count} tự động nhảy sau vài giây',
    'goOldLogin': 'Đăng nhập phiên bản cũ',
    'goNewLogin': 'Đăng nhập phiên bản mới',
    'siteTips': 'Để có trải nghiệm hệ thống tốt hơn, bạn có thể chọn chuyển sang quốc gia hoặc khu vực khác',
    'siteGo': 'Đi đến',
    'loginLoading': 'Tài khoản của bạn sẽ tự động đăng nhập vào hệ thống mới, vui lòng đợi trong giây lát',
    'sfExpress': 'Bản quyền thuộc về Shunfeng Express Transport số 08034243',
    'sgSfExpress': 'Bản quyền thuộc về Shunfeng Express Transport số 08034243',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': 'Trung tâm dịch vụ chứng nhận quốc tế',
    'jumpError': 'Chuyển địa chỉ không hợp pháp',
    'tips': 'Gợi ý',
    'tips1': 'Gợi ý',
    'confirm': 'Xác nhận',
    'agreeWith': 'I have read and agree to the ',
    'agreeAndContinue': 'Tôi đã đọc và đồng ý với Chính sách bảo mật',
    'agreeService': 'Tôi đã đọc và đồng ý với Điều khoản dịch vụ',
    'agreeUserAgreement': 'Tôi đã đọc và đồng ý với Thỏa thuận người dùng',
    'agreeEpesAcceptableUse': 'Tôi đã đọc và đồng ý với Chính sách sử dụng SF Korea ERP',
    'define': 'Xác nhận',
    'cancel': 'Hủy',
    'yes': 'Có',
    'no': 'Không',
    'sendAgain': 'Gửi lại',
    'second': 'giây',
    'iknow': 'Tôi hiểu',
    'country': 'Quốc gia/Lãnh thổ',
    'tel': 'Số điện thoại',
    'email': 'Email',
    'telNumber': 'Số điện thoại',
    'verifyCode': 'Mã xác minh',
    'sendVerificationCode': 'Gửi CAPTCHA',
    'next': 'Tiếp theo',
    'prev': 'Trước đó',
    'finished': 'Hoàn thành',
    'back': 'Trở lại',
    'backLogin': 'Trở lại để đăng nhập',
    'home': 'Trang Web chính thức',
    'home_os': 'KEX Express',
    'inquiry': 'Truy vấn',
    'add': 'Thêm',
    'edit': 'Chỉnh sửa',
    'del': 'Xóa',
    'batchDel': 'Xóa hàng loạt',
    'operating': 'Hoạt động',
    'clearInfo': 'Làm mới',
    'excelUpload': 'Tải tệp Excel lên',
    'serialNumber': 'Số thứ tự',
    'save': 'Lưu',
    'leastOne': 'Vui lòng đánh dấu vào dữ liệu bạn muốn xóa. ',
    'uploadFile': 'Tải tệp lên',
    'downloadExcel': 'Tải xuống mẫu excel',
    'pleaseInput': 'Vui lòng nhập ',
    'pleaseSelect': 'Vui lòng chọn',
    'isDel': 'Bạn có chắc muốn xóa các dữ liệu đã chọn? ',
    'agree': 'Đồng ý',
    'disagree': 'Không đồng ý',
    'uploadTotal': 'Tổng số lượt tải lên',
    'uploadSuccess': 'Tải lên thành công',
    'uploadFail': 'Tải lên thất bại',
    'checkAll': 'Chọn tất cả',
    'cancelContent': 'Yêu cầu hủy của tài khoản này đã được gửi vào [{cancelTime}], tài khoản sẽ được kích hoạt lại nếu bạn đăng nhập trong vòng 15 ngày kể từ ngày hủy. Bạn có muốn tiếp tục đăng nhập không? ',
    'ok': 'Được rồi.',
    'autoTip': 'Đang trong quá trình giám định, xin hãy chờ......',
    'feedback': 'Phản hồi / Đề xuất',
    'scanCode': 'Quét mã đăng nhập',
    'useWxScan': 'Quét bằng WeChat',
    'useWhatsAppScan': 'Sử dụng quét WhatsApp',
    'otherLoginWays': 'Các phương thức đăng nhập khác',
    'scanSuccessfully': 'Quét mã thành công',
    'confirmOnPhone': 'Vui lòng xác nhận trên điện thoại',
    'refreshQR': 'Click vào Refresh',
    'consult': 'Tư vấn hợp tác',
    'please_select_correct_phone': 'Vui lòng chọn đúng mã vùng điện thoại',
    '国际标快': 'Standard Express',
    '国际特惠': 'Economy Express',
    '顺丰集运': 'SFBUY',
    '国际电商专递': 'E-Commerce Express',
    '国际小包': 'E-Parcel',
    '海外仓': 'Overseas Fulfilment/Warehouse',
    '顺丰国际产品导航': 'Product Navigation'
  },
  'channel': {
    'gls': 'gls',
    'gls_tooltip': 'Mẹo công cụ'
  },
  'login': {
    'selectLoginType': 'Chọn phương thức đăng nhập',
    'personal': 'Đăng nhập tài khoản cá nhân',
    'enterprise': 'Đăng nhập tài khoản doanh nghiệp',
    'tel': 'Số điện thoại',
    'password': 'Mật khẩu',
    'verificationCodeLogin': 'Đăng nhập bằng mã xác minh',
    'verificationCode': 'Mã xác nhận',
    'obtainVerificationCode': 'Gửi mã xác minh',
    'passwordLogin': 'Đăng nhập bằng mật khẩu',
    'rememberPSD': 'Ghi nhớ/ Lưu',
    'rememberTips': 'Không khuyến khích đối với các thiết bị công cộng',
    'forgetPSD': 'Quên mật khẩu',
    'loginAgree': 'tôi đã đọc và đồng ý với',
    'agreeTips': 'Chính sách bảo mật',
    'epesAcceptableUse': 'Chính sách sử dụng SF Korea ERP',
    'userAgreement': 'Thỏa thuận người dùng',
    'login': 'Đăng nhập',
    'username': 'Tên người dùng',
    'email': 'Email',
    'phoneLogin': 'Đăng nhập bằng số điện thoại di động',
    'usernameLogin': 'Đăng nhập bằng tên người dùng',
    'emailLogin': 'Đăng nhập bằng email',
    'usernameOrEmailLogin': 'Đăng nhập bằng tên người dùng hoặc email',
    'registerNow': 'Đăng ký ngay ',
    'pleaseInput': '',
    'and': '&',
    'sfbuy_privacy': '《SFBuy Service Agreement(Chinese Mainland)》、《SFBuy Service Agreement(International/HK, MO and TW of China)》',
    'sfbuy_title': 'SFBuy',
    'aboutUs': 'Về chúng tôi',
    'serviceGuide': 'Hướng dẫn Newbie',
    'helpCenter': 'Trung tâm trợ giúp',
    'serviceAndPrice': 'Dịch vụ&Giá cả',
    'onlineCSR': 'Hỗ trợ trực tuyến',
    'copyright': 'Copyright  © 2023 Bản quyền thuộc về SF Express'
  },
  'register': {
    'personal': 'Đăng ký cá nhân',
    'enterprise': 'Đăng ký doanh nghiệp',
    'tel': 'Số điện thoại',
    'telVerificationCode': 'Mã xác minh điện thoại di động',
    'email': 'New Email',
    'emailVerificationCode': 'Nhập lại mật khẩu',
    'sendVerificationCode': 'Gửi CAPTCHA',
    'password': 'Vui lòng nhập mật khẩu',
    'passwordAgain': 'Nhập lại mật khẩu',
    'agree': 'Tôi đã đồng ý về ',
    'termsOfService': 'Điều khoản dịch vụ',
    'SFBuyService': 'Thỏa thuận dịch vụ mua SF',
    'and': '&',
    'privacyPolicy': 'Chính sách bảo mật',
    'registerNow': 'Đăng ký ngay ',
    'haveUserName': 'Bạn có tài khoản chưa?',
    'loginNow': 'Đăng nhập ngay',
    'toEmail': 'Đăng ký bằng email',
    'toTel': 'Đăng ký bằng số điện thoại ',
    'invitationCode': 'Mã lời mời',
    'timeCount': '(Phần còn lại, vui lòng đọc đến cuối)',
    'readBottom': '(Vui lòng đọc đến cuối)',
    'isFinshRead': 'Vui lòng đọc và đồng ý với Điều khoản Thông tin',
    sfbuy_policy1: '《SFBuy Service Agreement(Chinese Mainland)	》',
    sfbuy_policy2: '《SFBuy Service Agreement(International/HK, MO and TW of China)	》'
  },
  'resetPassword': {
    'resetTel': 'Cài đặt lại số điện thoại',
    'resetEmail': 'Đặt lại email',
    'tel': 'Số điện thoại',
    'telVerificationCode': 'Mã xác minh điện thoại di động',
    'email': 'New Email',
    'emailVerificationCode': 'Mã xác minh email',
    'sendVerificationCode': 'Gửi CAPTCHA',
    'newPassword': 'Mật khẩu mới',
    'confirmNewPassword': 'Xác nhận mật khẩu mới',
    'resetPassword': 'Đặt lại mật khẩu',
    'back': 'Trở lại',
    'login': 'Đăng nhập',
    'register': 'Đăng ký'
  },
  'modifyPassword': {
    'changePassword': 'Sửa đổi mật khẩu',
    'old': 'Mật khẩu cũ',
    'new': 'Mật khẩu mới',
    'confirm': 'Xác nhận mật khẩu mới'
  },
  'cookies': {
    'tip1': 'Trang web của chúng tôi sử dụng cookies để tối ưu hóa trải nghiệm người dùng và phân tích. Chúng tôi có thể chia sẻ thông tin của bạn với đối tác phân tích của chúng tôi',
    'tip2': 'Chính sách cookie',
    'tip3': 'Vui lòng cung cấp thêm thông tin. Nhấp vào để thay đổi các thiết lập',
    'tip4': 'Ở đây',
    'tip5': 'Bằng cách nhấp vào CHẤP NHẬN, bạn đồng ý với việc sử dụng cookie của chúng tôi theo lựa chọn của bạn',
    'disAgree': 'Từ chối',
    'cookieSet': 'Cài đặt cookie',
    'preference': 'Mục ưu tiên',
    'optimisation': 'Tối ưu hóa',
    'analytics': 'Phân tích',
    'neddCheck': 'Bạn phải đồng ý tùy chọn trước',
    'cookie': 'Chính sách cookie',
    'agree': 'Đồng ý',
    'preferenceCenter': 'Trung tâm ưu tiên'
  },
  'slideCircus': {
    'title': 'Vui lòng hoàn thành câu hỏi xác minh dưới đây',
    'change': 'Thay đổi',
    'right': 'Hãy giữ thanh trượt và kéo sang phải để hoàn thành câu hỏi',
    'pass': 'Đã xác minh',
    'verifyText': 'Vui lòng nhấp vào nút để xác minh',
    'verifying': 'Đang xác minh câu hỏi….',
    'loading': 'Đang tải hình ảnh lên'
  },
  'message': {
    'slideError': 'Slider service request failed',
    'selectTerms': 'Vui lòng kiểm tra và đánh dấu vào thông tin của các điều khoản',
    'verifyPass': 'Vui lòng bấm vào nút để xác minh',
    'registerSuccess': 'Đăng ký thành công',
    'sendTips0': 'Gửi thành công',
    'resetPasswordTips0': 'Mật khẩu đã được đặt lại thành công. ',
    'loginTips0': 'Đăng nhập thành công',
    'loginTips1': 'Đăng nhập thành công, tài khoản đã được kích hoạt',
    'modifiedTips0': 'Sửa đổi thành công',
    'switchLanguage': 'Chuyển đổi ngôn ngữ thành công',
    'switchSite': 'Chuyển đổi quốc gia thành công',
    'changeTel': 'Xin chúc mừng. Số điện thoại di động của bạn đã được sửa đổi thành công. Vui lòng đăng nhập lại!',
    'ChangeEmail': 'Sửa đổi Email',
    'cancelSuccess': 'Xin chúc mừng, tài khoản của bạn đã được hủy thành công!',
    'imgType': 'Vui lòng chọn lại ảnh, chỉ hỗ trợ định dạng JPG và PNG.',
    'imgSize': 'Vui lòng chọn lại ảnh, kích thước hình ảnh không thể vượt QUÁ 3MB!',
    'submitSuccess': 'Gửi thành công',
    'setSuccess': 'Cài đặt thành công',
    'delSuccess': 'Xóa thành công',
    'addSuccess': 'Thêm thành công',
    'fileType': 'Vui lòng chọn lại tệp, chỉ hỗ trợ các định dạng xls và xlsx!',
    'fileSize': 'Vui lòng chọn lại tệp, kích thước tệp không được vượt quá 15MB!',
    'delError': 'Xóa không thành công, thử lại sau',
    'uploadFile': 'Tải tệp lên',
    'uploadFileSuccess': 'Upload thành công',
    'selectedOne': 'Vui lòng nhập ít nhất 1 thông tin thủ tục hải quan hoặc ngày sinh',
    'imgTips1': 'Vui lòng tải lên hình ảnh ở định dạng {imgType}',
    'imgTips2': 'Ảnh đơn không thể vượt QUÁ 3MB',
    'imgTips3': 'Ảnh đơn không thể vượt QUÁ 10MB',
    'imgTips4': 'Bản xem trước tệp PDF không được hỗ trợ',
    'checkProduct': 'Vui lòng chọn sản phẩm',
    'clauseAgree': 'Vui lòng đồng ý với các điều khoản của hợp đồng vận chuyển điện tử',
    'estimatedCost': 'Vui lòng nhập phí ước tính trên mẫu dịch vụ bổ sung',
    'cardCode': 'Vui lòng nhập số thẻ cho COD trong bảng dịch vụ giá trị gia tăng',
    'threeTips': 'Thông tin mặt hàng chưa đầy đủ, vui lòng kiểm tra lại',
    'fourTips': 'Thông tin đặt hàng chưa đầy đủ, vui lòng kiểm tra lại',
    'noNeedUpload': 'Không cần tải lên giấy chứng nhận',
    'phoneOrFixAtLeastOne': 'Số điện thoại di động, số điện thoại cố định Vui lòng điền ít nhất một',
    'customerOrderNo': 'Vui lòng nhập số đặt hàng của khách hàng',
    'mas_003038': 'Tài khoản đăng nhập của bạn xuất hiện bất thường, xin vui lòng cập nhật trang web rồi thử đặt hàng.',
    'mas_003038_HTM': 'Bạn đăng nhập (số điện thoại di động) xuất hiện dị thường, xin vui lòng làm mới lại trang web rồi thử đặt hàng.',
    'mas_003035': 'Tài khoản của bạn đã được đăng ký, vui lòng đăng nhập trực tiếp từ IUOP.',
    'mas_auth_failed': 'Thẩm quyền thất bại'
  },
  'verify': {
    'selectAreaCode': 'Vui lòng chọn quốc gia/khu vực',
    'telTips': 'Vui lòng nhập số điện thoại di động',
    'telError': 'Vui lòng nhập chính xác số điện thoại di động.',
    'companyNameTrue': 'Vui lòng nhập chính xác tên công ty',
    'fixMobileCode': 'Vui lòng chọn mã vùng điện thoại cố định',
    'fixMobileNumber': 'Vui lòng nhập số điện thoại cố định',
    'fixMobileNumberReg': 'Vui lòng nhập chính xác số điện thoại cố định',
    'mobileVerificationCode': 'Vui lòng nhập mã bảo mật được gửi đến điện thoại của bạn',
    'emailAddress': 'Vui lòng nhập email',
    'emailTips': 'Vui lòng nhập email chính xác',
    'emailVerificationCode': 'Vui lòng nhập mã xác minh của email',
    'password': 'Vui lòng nhập mật khẩu',
    'passwordError': 'Mật khẩu có 8-20 chữ số, chỉ hỗ trợ 3 kết hợp chữ hoa chữ thường, số và ký hiệu trở lên',
    'passwordAgain': 'Vui lòng nhập lại mật khẩu',
    'passwordNotSame': 'Nhập khẩu đã nhập không tương thích, vui lòng nhập lại. ',
    'usernameTips': 'Vui lòng nhập tên người dùng',
    'usernameEmailTips': 'Vui lòng nhập tên người dùng/email của bạn',
    'telEmailTips': 'Vui lòng nhập số điện thoại(không yêu cầu số quốc gia)/hộp thư',
    'fixTelEmailTips': 'Vui lòng nhập đúng số điện thoại(không yêu cầu số quốc gia)/hộp thư',
    'selectTerms': 'Vui lòng kiểm tra và đánh dấu vào thông tin của các điều khoản',
    'accountName': 'Chỉ hỗ trợ 6-20 ký tự bắt đầu bằng một chữ cái và có thể chứa chữ cái, số và dấu gạch dưới',
    'verifyType': 'Vui lòng chọn chế độ xác minh',
    'verifyCode': 'Vui lòng nhập mã xác minh',
    'lastNameRequired': '"Họ"không được để trống',
    'firstNameRequired': '"Tên"không được để trống',
    'genderRequired': 'Giới tính không được để trống',
    'birthdayRequired': 'Ngày sinh không được để trống',
    'certTypeRequired': 'Loại chứng chỉ/ chứng nhận không được để trống',
    'certNoRequired': 'Số chứng minh thư không được để trống',
    'certExpireDateRequired': 'Hiệu lực của chứng chỉ không được để trống',
    'notSupTips': 'Số và các ký tự đặc biệt khác không được hỗ trợ',
    'certImage': 'Vui lòng tải lên ảnh chụp giấy tờ tùy thân của bạn trước khi gửi',
    'commodityName': 'Vui lòng nhập tên lô hàng',
    'quantity': 'Nhập Số lượng',
    'unit': 'Nhập đơn vị',
    'unitPrice': 'Nhập đơn vị giá',
    'placeOfOrigin': 'Vui lòng chọn nguồn gốc',
    'over0': 'Nhập số lớn hơn 0',
    'decimal3': 'Chỉ hỗ trợ 3 chữ số thập phân',
    'decimal6': 'Chỉ hỗ trợ 6 chữ số thập phân',
    'decimal10': 'Chỉ hỗ trợ 10 chữ số thập phân',
    'productRecordNo': 'Vui lòng nhập chính xác số hồ sơ thanh tra quốc gia',
    'hsCode': 'Nhập chính xác mã HS',
    'productCustomsNo': 'Nhập chính xác mã EORI',
    'contact': 'Nhập tên',
    'companyName': 'Nhập tên công ty',
    'country': 'Chọn quốc gia/ khu vực',
    'regionFirst': 'Vui lòng chọn Province City',
    'roadName': 'Nhập tên đường',
    'buildingNumber': 'Nhập số của tòa nhà',
    'addressDetail': 'Nhập địa chỉ chi tiết',
    'addressDetailTrue': 'Vui lòng nhập chính xác địa chỉ chi tiết ',
    'postalCode': 'Vui lòng nhập mã bưu điện',
    'phoneNumber': 'Nhập số điện thoại di động',
    'numberDecimal': 'Nhập số',
    'bangmecho': 'Nhập quận/ huyện, tên đường, số nhà',
    'shippingType': 'Chọn phương thức vận chuyển',
    'clearanceInfo': 'Chọn loại tài liệu',
    'idNumber': 'Vui lòng nhập số ID',
    'idNumberIsTrue': 'Nhập chính xác số ID',
    'contactCn': 'Nhập chính xác tên tiếng Trung',
    'receiveType': 'Chọn hình thức nhận ',
    'imgNumber': 'Tải lên ít nhất {number} hình ảnh',
    'papersTime': 'Chọn thời gian hiệu lực của chứng chỉ/ chứng nhận.',
    'declaredCurrency': 'Chọn đơn vị tiền tệ',
    'requred': 'Phần bắt buộc',
    'parcelTotalWeight': 'Nhập tổng trọng lượng',
    'contentMaxLength18': 'Hỗ trợ tối đa 18 số nguyên và 1 số thập phân',
    'contentIntOrFloatMaxLength': 'Hỗ trợ tối đa 12 số nguyên và 10 số thập phân',
    'atLeastSelectTip': 'Vui lòng chọn ít nhất một bản ghi',
    'invitationCode': 'Vui lòng nhập chính xác mã lời mời',
    'characterLength': 'Không dài hơn {length} ký tự',
    'pickUpTime': 'Chọn thời gian trả hàng tận nơi',
    'onlyNumberAndLetter': 'Chỉ hỗ trợ tổ hợp có cả số và chữ cái',
    'serviceFee': 'Phí ước tính cho các dịch vụ bổ sung hỗ trợ tối đa 12 số nguyên, 2 số thập phân',
    'methoedCode': 'Số thẻ của các dịch vụ bổ sung có thể hỗ trợ lên đến 20 chữ số',
    'contentInt14OrFloat2MaxLength': 'Hỗ trợ tối đa 14 số nguyên và 2 số thập phân ',
    'contentInt10OrFloat6MaxLength': 'Hỗ trợ tối đa 10 số nguyên và 6 số thập phân ',
    'contentInt18OrFloat6MaxLength': 'Hỗ trợ tối đa 18 số nguyên và 6 số thập phân ',
    'timeZoneCode': 'Chọn múi giờ',
    'contentInt14OrFloat1MaxLength': 'Hỗ trợ tối đa 14 số nguyên và 1 số thập phân',
    'contentInt15OrFloat5MaxLength': 'Hỗ trợ tối đa 15 số nguyên và 5 số thập phân'
  },
  'placeholder': {
    'countryCode': 'Vui lòng chọn quốc gia/khu vực',
    'telCode': 'Mã quận/ huyện',
    'phoneCode': 'Vui lòng nhập số điện thoại',
    'mobileVerificationCode': 'Vui lòng nhập mã bảo mật được gửi đến điện thoại của bạn',
    'verificationCode': 'Vui lòng',
    'emailAddress': 'Vui lòng nhập email',
    'emailVerificationCode': 'Mã xác minh email',
    'password': 'Vui lòng nhập mật khẩu',
    'checkPassword': 'Vui lòng nhập lại mật khẩu',
    'enter': 'Vui lòng nhập ',
    'username': 'Tên người dùng',
    'cardType': 'Chọn loại tài liệu',
    'uploadCard': 'Phù hợp với thông tin chứng chỉ/ chứng nhận',
    'uploadCardId': 'Vui lòng nhập số ID hợp lệ',
    'passwordError': 'Mật khẩu có 8-20 chữ số, chỉ hỗ trợ 2 kết hợp chữ hoa chữ thường, số và ký hiệu trở lên',
    'passwordAgain': 'Vui lòng nhập lại mật khẩu',
    'verifyType': 'Vui lòng chọn chế độ xác minh',
    'newEmail': 'Vui lòng chọn email bạn thường sử dụng',
    'addressBook': 'Nhập tên / tên công ty cho yêu cầu',
    'goodsWarehouse': 'Nhập tên lô hàng / mã HS cho yêu cầu',
    'clearanceWaybill': 'Vui lòng nhập số vận đơn 12 chữ số hoặc số vận đơn 15 chữ số bắt đầu bằng SF',
    'parcelTotalLength': 'Nhập độ dài',
    'parcelTotalWidth': 'Nhập chiều rộng',
    'parcelTotalHeight': 'Nhập chiều cao',
    'senderReason': 'Chọn lý do vận chuyển',
    'tradeCondition': 'Chọn các điều kiện thương mại',
    'senderReasonContent': 'Điền vào lý do vận chuyển phi thương mại',
    'businessRemark': 'Điền chú thích cho hóa đơn thương mại',
    'pickupAppointTime': 'Chọn ngày và giờ (thời gian nhận hàng trong khoảng 3 giờ sau khi hẹn)',
    'remarkText': 'Nhập thủ công văn bản ',
    'payMethod': 'Chọn phương thức thanh toán',
    'payMonthCard': 'Nhập số tài khoản tín dụng',
    'taxPayMethod': 'Nhập phương thức thanh toán thuế',
    'taxPayMonthCard': 'Nhập tài khoản quyết toán thuế',
    'serviceFee': 'Nhập phí ước tính',
    'feeCard': 'Nhập số thẻ COD',
    'invitationCode': 'Vui lòng nhập mã đăng ký / mã mời VIP',
    'willBay': 'Nhập số vận đơn',
    'senderCountry': 'Vui lòng chọn nơi gửi ban đầu',
    'receiverCountry': 'Chọn điểm đến',
    'receiverContact': 'Nhập tên người nhận',
    'orderStatus': 'Chọn trạng thái đơn hàng',
    'startTime': 'Ngày bắt đầu',
    'to': 'Đến',
    'endTime': 'Ngày kết thúc/ ngày hết hạn',
    'timeZoneCode': 'Chọn múi giờ'
  },
  'tagsView': {
    'refresh': 'Làm mới',
    'close': 'Đóng',
    'closeOthers': 'Đóng những mục khác',
    'closeAll': 'Đóng tất cả'
  },
  'exit': {
    'title': 'Đăng xuất',
    'message': 'Xác nhận để thoát？',
    'success': 'Thoát thành công!',
    'cancel': 'Hủy thoát',
    'close': 'Hủy thành công'
  },
  'notFind': {
    'oops': '404',
    'info': 'Xin lỗi, trang bạn đang truy cập không thể thoát',
    'backHome': 'Về trang chủ'
  },
  'settings': {
    'title': 'Trung tâm Dịch vụ Chứng nhận Quốc tế'
  },
  'role': {
    'admin': 'Người quản lý',
    'user': 'Người dùng thông thường'
  },
  'route': {
    'Login': 'Đăng nhập',
    '顺丰国际产品导航': 'Product Navigation',
    'Register': 'Đăng ký',
    'ResetPassword': 'Tìm mật khẩu',
    'UserCenter': 'Hồ sơ',
    'MyInfomation': 'Thông tin của tôi',
    'AccountInfomation': 'Thông tin tài khoản',
    'BaseInfomation': 'Thông tin cơ bản',
    'AccountSecurity': 'Bảo mật tài khoản',
    'ProtocolManage': 'Quản lý ký kết',
    'AccountSetting': '	Cài đặt Tài khoản',
    'BindingEmail': 'Liên kết với Email',
    'BindingPhone': 'Liên kết với số điện thoại',
    'CancelAccount': 'Hủy tài khoản',
    'ChangeEmail': 'Sửa đổi Email',
    'ChangePassword': 'Thay đổi mật khẩu',
    'ChangePhone': 'Thay đổi số điện thoại',
    'Name': 'Đặt tên người dùng',
    'ToMail': 'Tạo đơn hàng',
    'MailProduct': 'Vận chuyển hàng hóa',
    'AddressBook': 'Sổ địa chỉ',
    'GoodsWarehouse': 'Thư viện bài viết',
    'Order': 'Quản lý đơn hàng',
    'OrderIndex': 'Danh sách đặt hàng',
    'OrderAdd': 'Tạo đơn hàng lẻ',
    'Clearance': 'Thông tin thủ tục hải quan',
    'UploadPhotoid': 'Tải lên chứng chỉ/ chứng nhận',
    'EditOrder': 'Chỉnh sửa đơn hàng',
    'permission': 'Quản lý quyền',
    'permission_system': 'Quản lý hệ thống',
    'permission_role': 'Quản lý vai trò',
    'permission_resource': 'Quyền tài nguyên',
    'permission_user': 'Quản lý người dùng'
  },
  'button': {
    'sumbit': 'Nộp, gửi'
  },
  'accountInfo': {
    'username': 'Tên người dùng',
    'firstname': 'Tên ',
    'lastname': 'Họ',
    'sex': 'Giới tính',
    'man': 'Nam',
    'woman': 'Nữ',
    'telNumber': 'Số điện thoại:',
    'telNumberNot': 'Tài khoản của bạn không liên kết với số điện thoại di động.',
    'email': 'New Email',
    'emailNot': 'Tài khoản của bạn không liên kết với email',
    'binding': 'Liên kết ngay',
    'changeTel': 'Thay đổi số điện thoại',
    'changeEmail': 'Xin chúc mừng bạn, hộp thư của bạn đã được sửa đổi thành công, xin vui lòng đăng nhập lại!',
    'validated': 'Xác thực',
    'autoGeneration': 'Tự động tạo ra',
    'usernameTips': 'Tên người dùng không thể thay đổi sau khi thiết lập',
    'birthday': 'Ngày sinh',
    'birthday1': 'Ngày sinh',
    'autoCreate': 'Tự động tạo'
  },
  'baseInfo': {
    'cardType': 'Loại chứng chỉ/ chứng nhận',
    'firstname': 'Tên ',
    'lastname': 'Họ',
    'cardId': 'Số chứng chỉ',
    'cardTime': 'Hiệu lực của chứng chỉ',
    'cardImg': 'Hình ảnh giấy tờ: ',
    'cardLangTime': 'Có giá trị vĩnh viễn',
    'uploadImg': 'Tải lên hình ảnh',
    'titleTips': 'Mẹo nhỏ: Tên thật được yêu cầu bởi quốc gia gửi lô hàng để làm thủ tục hải quan, thông tin chứng chỉ sẽ được đóng dấu độc quyền thông quan. SF sẽ đảm bảo an toàn thông tin của bạn.',
    'dialogTitle': 'Ví dụ tiêu chuẩn',
    'dialogTips': 'Ảnh chụp chứng chỉ phải hoàn chỉnh và văn bản phải rõ ràng, không bị phản chiếu ánh sáng và vật che chắn. Nếu quá mờ, quá trình xác minh sẽ không thành công!',
    'cardUp': 'Mặt trước của chứng chỉ',
    'cardDown': 'Mặt sau của chứng chỉ'
  },
  'emailLink': {
    'tips': 'Vui lòng đặt mật khẩu tài khoản',
    'setPassword': 'Đặt mật khẩu',
    'success': 'Tài khoản được kích hoạt thành công'
  },
  'accountSecurity': {
    'ChangePassword': 'Thay đổi mật khẩu',
    'ChangePasswordDesc': 'Nếu mật khẩu bị quên do bạn đã không đăng nhập trong một thời gian dài, bạn có thể đặt lại mật khẩu sau khi xác minh danh tính.',
    'BindingPhone': 'Liên kết với số điện thoại',
    'BindingPhoneDesc': 'Số điện thoại di động liên kết có thể được sử dụng để đăng nhập, lấy lại mật khẩu, đặt hàng và các dịch vụ khác.',
    'BindingEmail': 'Liên kết với Email',
    'BindingEmailDesc': 'Email liên kết có thể được sử dụng để đăng nhập, lấy lại mật khẩu, đặt hàng và các dịch vụ khác.',
    'SettingName': 'Đặt tên người dùng',
    'firstname': 'first name',
    'lastname': 'last name',
    'SettingRealName': 'Set First name&Last name	',
    'SettingRealNameDesc': 'Set personal name information as an account attribute that can be edited multiple times.',
    'SettingNameDesc': 'Bạn có thể sử dụng tên người để đăng nhập và tên người dùng không thể sửa đổi sau khi cài đặt',
    'immediatelySet': 'Thiết lập ngay bây giờ',
    'alreadySet': 'Cài',
    'settingComplete': 'Thiết lập hoàn tất',
    'alreadyBinding': 'Liên kết',
    'userName': 'Tên người dùng',
    'userNameLogin': 'Tên người dùng không thể sửa đổi sau khi cài đặt',
    'selfCreate': 'Tự động tạo',
    'stopEdit': 'Tên người dùng không thể sửa đổi sau khi cài đặt',
    'setOk': 'Cài đặt xong',
    'cancelAccount': 'Hủy tài khoản',
    'cancelAccountTips': 'Hãy thận trọng, không thể khôi phục dữ liệu sau khi hủy',
    'toCancel': 'Hủy ngay bây giờ',
    'cancelToKnow': 'Thỏa thuận hủy tài khoản',
    'cancelDesc1': '1. Tài khoản này là tài khoản hợp nhất của SF International. Khi bị hủy trên các nền tảng liên quan đến SF International, tài khoản sẽ không thể được sử dụng và khôi phục trên các nền tảng của SF International. Hãy thận trọng, vui lòng sao lưu tất cả các thông tin và dữ liệu trước khi hoạt động;',
    'cancelDesc2': '2. Đồng ý hủy bỏ nghĩa là bạn từ bỏ tất cả các đặc quyền thành viên và tài sản ảo (bao gồm nhưng không giới hạn ở điểm thưởng thành viên, cấp độ thành viên, các đặc quyền và phiếu giảm giá, v.v.);',
    'cancelDesc3': '3. Sau khi hủy, bạn không thể đăng nhập, sử dụng tài khoản này và tìm thấy bất kỳ nội dung hoặc thông tin nào liên quan đến tài khoản này, bao gồm nhưng không giới hạn ở tên người dùng và các biểu tượng (thông tin vận đơn sẽ được lưu theo thời hạn mà các chính sách bảo mật đã thỏa thuận , bạn có thể kiểm tra thông tin tuyến đường với số vận đơn trên trang web chính thức của SF);',
    'cancelDesc4': '4. Nếu bạn đã kích hoạt số tài khoản tín dụng, sau khi hủy bỏ, mối liên kết của tài khoản này và tài khoản tín dụng của bạn sẽ không còn; nếu bạn cần tiếp tục sử dụng số tài khoản tín dụng, bạn cần phải liên kết với tài khoản mới;',
    'cancelDesc5': '5. Việc hủy bỏ tài khoản không làm mất đi hoặc giảm nhẹ trách nhiệm pháp lý liên quan của các hành vi trước khi tài khoản bị hủy;',
    'cancelDesc6': '6. Yêu cầu hủy bỏ này có thể được hủy trong vòng 15 ngày. Trong vòng 15 ngày kể từ ngày hủy, người dùng có thể hủy tài khoản bằng cách đăng nhập lại.',
    'cancelAgree': 'Tôi đã đọc và đồng ý với Thỏa thuận hủy tài khoản',
    'cancelTitle': 'Đăng xuất tài khoản',
    'cancelConfirm': 'Xác nhận để hủy tài khoản ngay bây giờ',
    'cancelTips': 'Vui lòng đọc và đồng ý về thông báo hủy tài khoản',
    'goBinding': 'Liên kết ngay',
    'changeBinding': 'Thay đổi liên kết ngay lập tức',
    'auth': 'Xác thực danh tính',
    'finish': 'Hoàn tất thay đổi',
    'binding': 'Hoàn tất việc liên kết',
    'verifyType': 'Chế độ xác minh',
    'ChangePhone': 'Thay đổi số điện thoại',
    'ChangeEmail': 'Sửa đổi Email',
    'tips1': 'Chúc mừng, mật khẩu của bạn được đổi thành công',
    'tips2': 'Chúc mừng, số điện thoại của bạn được đổi thành công',
    'tips3': 'Chúc mừng, email của bạn được đổi thành công',
    'tips4': 'Chúc mừng, số điện thoại của bạn đã được liên kết thành công',
    'tips5': 'Chúc mừng, email của bạn đã được liên kết thành công',
    'tips6': 'Xin chúc mừng, tên người dùng đã được thiết lập thành công'
  },
  'accountConflict': {
    'title': 'xác nhận tài khoản',
    'desc1': 'Khách hàng thân mến,',
    'desc2': 'Hệ thống đã phát hiện ra rằng Email / điện thoại di động của bạn đã được đăng ký trên nhiều hệ thống của công ty chúng tôi. Để cải thiện trải nghiệm của bạn, vui lòng chọn một trong các tài khoản đăng nhập của bạn làm tài khoản đăng nhập thống nhất của nhiều hệ thống.',
    'desc3': 'Sau khi bấm “Xác nhận”, hệ thống sẽ gửi Email hoặc SMS để bạn đặt lại mật khẩu. Vui lòng làm theo chỉ dẫn và giữ nó đúng cách.',
    'loginName': 'Tên đăng nhập',
    'phone': 'Số điện thoại',
    'registerSys': 'Hệ thống đăng ký',
    'registerTime': 'Thời gian đăng kí',
    'newRegister': 'Một đăng ký mới',
    'infoVer': 'Xác minh thông tin',
    'inforVerSelect': 'Vui lòng chọn phương pháp xác thực',
    'selectOne': 'Vui lòng chọn một trong các tài khoản đăng nhập của bạn',
    'IBS': 'Hệ thống quản lý đơn hàng và lô hàng',
    'ICAS': 'Hệ thống tài khoản khách hàng quốc tế',
    'IUOP': 'Nền tảng đặt hàng thống nhất quốc tế',
    'IBSE': 'Hệ thống kinh doanh quốc tế xuất khẩu',
    'PMS': 'Nhập hệ thống kinh doanh quốc tế',
    'IBSI': 'Thương gia quốc tế Logistics nhập khẩu',
    'SFBUY': 'SFBUY',
    'POP': 'Đối tác nền tảng mở',
    'SFGOAPP': 'SF GO',
    'IFTP': 'Nền tảng vận chuyển hàng hóa quốc tế',
    'OFTP': 'Nền tảng vận chuyển hàng hóa nước ngoài'
  },
  'permission': {
    'reset': 'Đặt lại',
    'enable': 'Bật',
    'disable': 'Tắt',
    'delete': 'Xoá',
    'deleteBatch': 'Xóa hàng loạt',
    'remark': 'Lưu ý',
    'sort': 'Sắp xếp',
    'confirm': 'Xác nhận',
    'cancel': 'Hủy',
    'operation': 'Hoạt động',
    'modify': 'Sửa đổi',
    'select': 'Vui lòng chọn',
    'input': 'Vui lòng nhập tên người dùng hoặc số',
    'query': 'Yêu cầu',
    'edit': 'Chỉnh sửa',
    'required_rule': 'Dữ liệu không được để trống',
    'success': 'Hoạt động thành công',
    'fail': 'Hoạt động thất bại',
    'length_rule': 'Độ dài từ {min} đến {max} ký tự',
    'deleteTip1': 'Vui lòng vô hiệu hóa tất cả các hệ thống con bên dưới "{name}"trước',
    'deleteTis': "Xác nhận xóa mục dữ liệu có tên'{name}'không?",
    'deleteChildTis': 'Tất cả các hệ thống trong hệ thống này sẽ bị xóa.',
    'tis': 'Mẹo',
    'deleteBatchTis': 'Xác nhận xóa dữ liệu {num} đã chọn?',
    'enableTis': 'Xác nhận {num} dữ liệu được chọn bởi {statusName}?',
    'msgError': 'Dữ liệu hoạt động bị lỗi',
    'codeCheckRule': 'Cho phép chữ hoa chữ thường, số, ""hoặc "-"',
    'checkMinCharacter': 'Vui lòng nhập {min} nhiều hơn các ký tự',
    'roleType_0': 'Vai trò tự xây dựng',
    'roleType_1': 'Quản trị hệ thống',
    'bindResource': 'Tài nguyên liên kết',
    'roleList': 'Danh sách nhân vật',
    'roleAdd': 'Nhân vật mới',
    'roleEdit': 'Vai trò biên tập',
    'roleConfig': 'Cấu hình vai trò',
    'childSystemName': 'Hệ thống con Name',
    'roleNo': 'Số nhân vật',
    'roleName': 'Tên nhân vật',
    'roleDescribe': 'Mô tả vai trò',
    'isSystem': 'Hệ thống sở hữu',
    'roleType': 'Loại role',
    'userStatus_0': 'Chưa kích hoạt',
    'userStatus_1': 'Kích hoạt',
    'userStatus_2': 'Đăng xuất trước',
    'userStatus_3': 'Đăng xuất',
    'userStatus_4': 'Tắt',
    'userStatus_5': 'Khóa',
    'userRoleEdit': 'Xem/Chỉnh sửa Vai trò',
    'userList': 'Danh sách người dùng',
    'regtime': 'Thời gian đăng ký',
    'userCode': 'Số người dùng',
    'area': 'Khu vực phụ thuộc',
    'nickName': 'Biệt danh',
    'sourceSystem': 'Hệ thống nguồn',
    'userStatus': 'Trạng thái',
    'systemList': 'Danh sách hệ thống',
    'systemAdd': 'Hệ thống mới',
    'systemModify': 'Sửa đổi hệ thống',
    'systemName': 'Tên hệ thống',
    'systemType': 'Loại hệ thống',
    'systemType_0': 'Dữ liệu chính',
    'systemType_1': 'Hệ thống kinh doanh',
    'systemCode': 'Mã hóa hệ thống',
    'systemStatus': 'Trạng thái hệ thống',
    'systemStatus_0': 'Bật',
    'systemStatus_1': 'Tắt',
    'systemAddChildren': 'Thêm hệ thống con',
    'systemSuperior': 'Hệ thống cao hơn',
    'resourceList': 'Danh sách tài nguyên',
    'resourceAdd': 'Tài nguyên mới',
    'resourceModify': 'Sửa đổi tài nguyên',
    'resourceName': 'Tên tài nguyên',
    'resourceType': 'Loại tài nguyên',
    'resourceType_MENU': 'Thực đơn',
    'resourceType_MODULE': 'Thư mục',
    'resourceType_WIDGET': 'Nút bấm',
    'resourceCode': 'Mã hóa tài nguyên',
    'resourceStatus': 'Tình trạng tài nguyên',
    'resourceStatus_true': 'Bật',
    'resourceStatus_false': 'Tắt',
    'resourceAddChildren': 'Mục con mới',
    'resourceSuperior': 'Thực đơn cao hơn',
    'icon': 'Kiểu biểu tượng',
    'iconActive': 'Biểu tượng hoạt động',
    'shortName': 'Viết tắt',
    'resourceUrl': 'URL tài nguyên',
    'resourceFun': 'URL chức năng',
    'openType': 'Cách mở',
    'openType_0': 'Định tuyến trang',
    'openType_1': 'Cửa sổ mới',
    'pub': 'Cần kiểm soát quyền',
    'pub_true': 'Vâng',
    'pub_false': 'Không',
    'hidden': 'Ẩn hay không',
    'hidden_0': 'Vâng',
    'hidden_1': 'Không',
    'selectSystem': 'Vui lòng chọn hệ thống trước'
  },
  'protocol': {
    'num': 'Số',
    'protocolName': 'Tên giao thức',
    'protocolNo': 'Số phiên bản giao thức',
    'signTime': 'Thời gian ký kết',
    'remark': 'Lưu ý',
    'signUser': 'Đăng ký tài khoản',
    'signName': 'Đăng ký tên khách hàng',
    'signChild': 'Số phiên bản con của giao thức'
  },
  'sfbuy': {
    'wechatScane': 'WeChat lướt qua',
    'wechatScane1': 'Làm chủ kịp thời',
    'wechatScane2': 'Động thái WeChat',
    'onlineService': 'Hỗ trợ trực tuyến',
    'aboutUs': 'Về chúng tôi',
    'serviceGuide': 'Hướng dẫn Newbie',
    'helpCenter': 'Trung tâm trợ giúp',
    'serviceAndPrice': 'Dịch vụ&Giá cả',
    'announcement': 'Thông báo',
    'important': 'Quan trọng'
  },
  messageNotice: {
    'yxDetail': 'chi tiết',
    'optional': 'tùy chọn',
    'loginXyAgree': 'Tôi đồng ý nhận thông báo tiếp thị và quảng cáo',
    messageNotice: 'Thông báo Tin nhắn',
    messageNoticeDesc: 'Hỗ trợ chỉnh sửa cấu hình thông báo',
    messageNoticeBtn: 'Sửa đổi cấu hình',
    messageNoticeTitle: 'Cấu hình thông báo tiếp thị',
    messageNoticeTitleDesc1: 'Xem ',
    messageNoticeTitleDesc2: ' thu thập thông tin cá nhân. Tích chọn đồng ý nhận tiếp thị và quảng cáo',
    messageNoticeDetailTitle: 'Chi tiết thu thập thông tin tiếp thị',
    message: 'Tin nhắn SMS',
    messageNotcieDialogTitle: 'Cấu hình Kênh Tiếp thị',
    considerLater: 'Sẽ xem xét sau',
    messageNotcieDialogDesc1:
    'Nhấp vào nút xác nhận đồng nghĩa với việc bạn đồng ý cho chúng tôi sử dụng các kênh sau để gửi các chiến dịch tiếp thị và quảng cáo mà bạn có thể quan tâm. ​',
    messageNotcieDialogDesc2: 'về việc thu thập thông tin cá nhân xem tại đây.',
    messageNotcieDialogDetail: 'Chi tiết',
  },
  weakPassword: {
    提示: 'Mẹo',
    账号异常提醒: 'Tài khoản của bạn có hoạt động bất thường. Vui lòng đổi mật khẩu hoặc dùng mã xác thực/quét mã QR để đăng nhập.',
    修改密码: 'Đổi mật khẩu',
    关闭: 'Đóng',
    账号异常处理: 'Xử lý tài khoản bất thường',
    绑定提示: 'Vui lòng liên kết số điện thoại hoặc email trước, sau đó đổi mật khẩu',
    账号: 'Tài khoản'
  },
  recommendedPassword: {
    使用推荐密码: 'Sử dụng mật khẩu được đề xuất',
    提示: 'Lưu ý',
    请保管好您的密码:
      'Vui lòng bảo quản mật khẩu của bạn cẩn thận. Khuyến nghị bạn nên thay đổi kịp thời sau khi đăng nhập.',
    复制密码: 'Sao chép Mật khẩu',
    psd: 'Mật khẩu',
    copySuccess: 'Sao chép thành công',
    注册成功: 'Chúc mừng bạn đã đăng ký thành công!',
    注册建议: 'Để bảo đảm an toàn tài khoản, khuyến nghị:',
    修改密码: 'Truy cập "Trung tâm Quản lý - Cài đặt tài khoản" để thay đổi mật khẩu.'
  },
  twoFactorAuth: {
    双因素认证: 'xác thực hai yếu tố',
    认证方式: '	Phương thức xác thực',
    为了您的账号安全: 'Để bảo mật tài khoản của bạn, vui lòng hoàn thành xác thực hai yếu tố trước khi đăng nhập.',
    请选择绑定: 'Vui lòng chọn để liên kết.:',
    请先设置您的密码: 'Vui lòng đặt mật khẩu của bạn trước'
  },
  sendType: {
    您当前手机区号不支持whatsapp: 'Mã vùng điện thoại hiện tại của bạn không hỗ trợ {noticeChanel}, vui lòng chọn phương thức khác để nhận mã xác minh',
    请使用绑定手机号接收验证码: 'Vui lòng sử dụng số điện thoại đã liên kết để nhận mã xác minh',
    请使用绑定邮箱接收验证码: 'Vui lòng sử dụng email đã liên kết để nhận mã xác minh',
    请选择验证码接收方式: 'Vui lòng chọn phương thức nhận mã xác minh'
  },
  recommendFloat: {
    '满意度评价': 'Đánh giá mức độ hài lòng',
    '您的评价对我们很重要': 'Đánh giá của bạn rất quan trọng đối với chúng tôi',
    '我要评价': 'Tôi muốn đánh giá'
  }
}
